import { Accordion, Box, Text } from '@zillow/constellation-10';
import { IconDollarSignCircleFilled, IconLockClosedFilled, IconSendFilled } from '@zillow/constellation-icons';
import BenefitSection from './BenefitSection';

const CONTENT = {
  ACCORDION_TITLE: 'The benefits of paying with Zillow',
  BENEFITS: [
    {
      icon: <IconDollarSignCircleFilled />,
      title: 'More ways to pay',
      description:
        'Freedom from checks means you can pay with your debit/credit card, or direct debit from your bank account.',
    },
    {
      icon: <IconSendFilled />,
      title: 'Pay from anywhere',
      description: "Pay on the go, or schedule your payments on time, it's up to you.",
    },
    {
      icon: <IconLockClosedFilled />,
      title: 'Your security is our priority',
      description: 'We partner with payment-security experts and never sell your information.',
    },
  ],
} as const;

const BenefitsAccordion = () => {
  return (
    <Accordion.Root>
      <Accordion.Item value="benefits">
        <Accordion.Header>
          <Text textStyle="body">{CONTENT.ACCORDION_TITLE}</Text>
        </Accordion.Header>
        <Accordion.Panel>
          <Box
            css={{
              display: 'flex',
              flexDirection: 'column',
              gap: 'looser',
              padding: '{spacing.default} {spacing.none}',
            }}
          >
            {CONTENT.BENEFITS.map((benefit, index) => (
              <BenefitSection key={index} icon={benefit.icon} title={benefit.title} description={benefit.description} />
            ))}
          </Box>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion.Root>
  );
};

export default BenefitsAccordion;
